/*
  Action Types
 */

export const GET_ADDRESS_UPDATE_DETAILS = "GET_ADDRESS_UPDATE_DETAILS";
export const GET_ADDRESS_UPDATE_DETAILS_SUCCESS = "GET_ADDRESS_UPDATE_DETAILS_SUCCESS";
export const GET_ADDRESS_UPDATE_DETAILS_FAILURE = "GET_ADDRESS_UPDATE_DETAILS_FAILURE";

export const APPROVE_ADDRESS = "APPROVE_ADDRESS";
export const APPROVE_ADDRESS_SUCCESS = "APPROVE_ADDRESS_SUCCESS";
export const APPROVE_ADDRESS_FAILURE = "APPROVE_ADDRESS_FAILURE";

export const addressFields = ["address", "address2", "city", "state", "postcode"];

export const addressUpdateStatus = {
  approved: "APPROVED",
  rejected: "REJECTED",
  actionRequired: "ACTIONREQUIRED"
};

export const modes = {
  addressUpdate: "addressUpdate"
};


// WEBPACK FOOTER //
// ./app/admin/constants/adminConstants.js